import { computed, ref } from 'vue';

const PHONE_QUERY = "(max-width: 767px)";
const MOBILE_QUERY = "(max-width: 1023px)";

const matchQuery = (mediaQuery) => {
  if (typeof window.matchMedia !== 'function') return ref(false);

  const list = window.matchMedia(mediaQuery);
  const matches = ref(list.matches);
  const update = (event) => matches.value = event.matches;

  // MediaQueryList only gained addEventListener in Safari 14.
  if (list.addEventListener) {
    list.addEventListener('change', update);
  } else {
    list.addListener(update);
  }

  return matches;
}

const mobileView = matchQuery(MOBILE_QUERY);
const phoneView = matchQuery(PHONE_QUERY);
const desktopView = computed(() => !mobileView.value);

export default () => {
  return {
    mobileView,
    desktopView,
    phoneView
  }
}
